import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-06-22
 * @brief SEI Report 컴포넌트
 *
 ********************************************************************/
// recoil
import { useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { curConsultingState, curReportState, curTotalState, reportTypeState } from "../../../recoil/assessmentState";
import { reLoadState, reloadAlert, reloadSpg } from "../../../recoil/userState";
//
function ReportTree(props) {
    //recoil
    const setReloadState = useSetRecoilState(reLoadState);
    const setReloadspg = useSetRecoilState(reloadSpg);
    const setReloadAlerts = useSetRecoilState(reloadAlert);
    const setRecoilTreeData = useSetRecoilState(curReportState);
    const setRecoilTotalData = useSetRecoilState(curTotalState);
    const setRecoilEnergyData = useSetRecoilState(curConsultingState);
    const [check, setChceck] = useRecoilState(reportTypeState);
    const { reportList, treeSel, setTreeSel, work, setWork, mobileTree, setMobileTree } = props;
    const [isOpen, setIsOpen] = useState(reportList.find((report) => report.type === treeSel.type && report.dept === 1).name);
    const subTreeClick = (report) => {
        setRecoilTreeData({
            companyId: "",
            zoneId: "",
            subZoneId: "",
            name: "",
            roomId: "",
            roomName: "",
            spgId: -1,
            spgName: "",
        });
        setRecoilEnergyData({
            companyId: "",
            name: "",
            zoneId: "",
        });
        setMobileTree(false);
        setReloadspg(true);
        setReloadState(true);
        setTreeSel(report);
        setWork(report.type);
        setReloadAlerts(false);
        setChceck(Object.assign(Object.assign({}, check), { smenu: report.type }));
        if (treeSel !== report) {
            window.scrollTo({ top: 0 });
        }
        return;
    };
    const treeClick = (report) => {
        if (report.children) {
            setIsOpen(report.name);
            subTreeClick(reportList.find((item) => item.type == report.type && item.dept == 2));
            return;
        }
        setIsOpen(report.name);
        setRecoilTreeData({
            companyId: "",
            zoneId: "",
            subZoneId: "",
            name: "",
            roomId: "",
            roomName: "",
            spgId: -1,
            spgName: "",
        });
        setRecoilTotalData({
            companyId: "",
            companyName: "",
            id: -1,
        });
        setRecoilEnergyData({
            companyId: "",
            name: "",
            zoneId: "",
        });
        setMobileTree(false);
        setReloadspg(true);
        setReloadState(true);
        setTreeSel(report);
        setWork(report.type);
        setChceck(Object.assign(Object.assign({}, check), { smenu: report.type }));
        setReloadAlerts(false);
        if (work !== report) {
            window.scrollTo({ top: 0 });
        }
        return;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: `box treebar pushy-menutype navy report m-none` }, { children: _jsx("div", Object.assign({ className: "lnb" }, { children: _jsx("ul", Object.assign({ className: "lnb-depth1" }, { children: reportList
                            .filter((item) => item.dept == 1)
                            .map((report) => (_jsxs("li", Object.assign({ className: report.name == isOpen ? "active" : "" }, { children: [_jsx("p", Object.assign({ onClick: () => treeClick(report) }, { children: _jsx("a", { children: _jsx("span", { children: report.name }) }) })), report.children && (_jsx("ul", Object.assign({ className: "lnb-depth2" }, { children: reportList
                                        .filter((item) => item.dept == 2)
                                        .map((dept2) => report.type == dept2.type && (_jsx("li", Object.assign({ className: treeSel.code == dept2.code ? "active" : "", onClick: () => subTreeClick(dept2) }, { children: _jsx("a", { children: dept2.name }) }), dept2.name))) })))] }), report.name))) })) })) })), _jsx("div", Object.assign({ className: `box treebar menutype report m-block ${mobileTree ? "active" : ""}` }, { children: _jsx("div", Object.assign({ className: "manuarea" }, { children: _jsx("ul", Object.assign({ className: "manulist" }, { children: reportList.map((report) => (_jsx("li", Object.assign({ className: report.dept == 1
                                ? `${report.name == treeSel.name ? "on" : ""} title-line bg-white brd-bottom-0 ${!report.children ? "arrow" : ""}`
                                : `${report.name == treeSel.name ? "on" : ""} brd-bottom-0` }, { children: report.children ? (_jsx("p", { children: report.name })) : (_jsx("a", { children: _jsx("p", Object.assign({ onClick: () => treeClick(report) }, { children: report.name })) })) }), report.name))) })) })) }))] }));
}
export default ReportTree;
